import React, { CSSProperties, PureComponent } from 'react';
import { Handles, Rail, Slider, Tracks } from 'react-compound-slider';
import {
  Handle,
  SliderRail,
  SliderRailTooltip,
  Track,
} from './SliderComponents';
import _cssVars from '../../../styles/shared.module.scss';

const sliderStyle: CSSProperties = {
  position: 'relative',
  width: '100%',
};

interface PropTypes {
  domain: ReadonlyArray<number>;
  values: ReadonlyArray<number>;
  update?: ReadonlyArray<number>;
  onUpdate?: (update: ReadonlyArray<number>) => void;
  onChange?: (change: ReadonlyArray<number>) => void;
  getDisplayValue?: (value: number, percent: number) => string;
}

export default class DefaultSlider extends PureComponent<PropTypes> {
  static defaultProps = {
    domain: [1, 24],
    values: [0, 24],
    update: [0, 24],
    reversed: false,
  };

  render() {
    const {
      props: { domain, values, onUpdate, onChange, getDisplayValue },
    } = this;

    return (
      <div
        style={{
          height: _cssVars.handleSize,
          width: '100%',
          marginTop: '1.2rem',
        }}
      >
        <Slider
          mode={3}
          step={1}
          domain={domain}
          reversed={false}
          rootStyle={sliderStyle}
          onUpdate={onUpdate}
          onChange={onChange}
          values={values}
        >
          <Rail>
            {railProps => (
              <SliderRailTooltip
                getDisplayValue={getDisplayValue}
                {...railProps}
              />
            )}
          </Rail>
          <Rail>
            {railProps => (
              <>
                <SliderRail {...railProps} />
              </>
            )}
          </Rail>

          <Tracks left={false} right={false}>
            {({ tracks, getTrackProps }) => (
              <>
                {tracks.map(({ id, source, target }) => (
                  <Track
                    getDisplayValue={getDisplayValue}
                    key={id}
                    source={source}
                    target={target}
                    getTrackProps={getTrackProps}
                  />
                ))}
              </>
            )}
          </Tracks>

          <Tracks left={false} right={false}>
            {({ tracks, getTrackProps }) => (
              <>
                {tracks.map(({ id, source, target }) => (
                  <Track
                    key={id}
                    source={source}
                    target={target}
                    getTrackProps={getTrackProps}
                  />
                ))}
              </>
            )}
          </Tracks>

          <Handles>
            {({ handles, getHandleProps }) => (
              <>
                {handles.map(handle => (
                  <Handle
                    values={values}
                    getDisplayValue={getDisplayValue}
                    key={handle.id}
                    handle={handle}
                    domain={domain}
                    getHandleProps={getHandleProps}
                  />
                ))}
              </>
            )}
          </Handles>
        </Slider>
      </div>
    );
  }
}
